import {usePatientQuestionnaire} from '~/services/api/MedicalHistory/Questionnaire/hooks';
import Loading from '~/components/Loading';
import FetchError from '~/components/FetchError';
import FamilyQuestionnaireForm from './form';
import {QuestionnaireType} from '~/services/api/MedicalHistory/Questionnaire/types';

interface FamilyQuestionnaireProps {
  patientId: number;
  currentPage: number;
  itemsPerPage: number;
  handlePageChange: (page: number) => void;
  handleBack: () => void;
  patientName?: string;
}

const FamilyQuestionnaire = (props: FamilyQuestionnaireProps) => {
  const {
    currentPage,
    handleBack,
    handlePageChange,
    itemsPerPage,
    patientId,
    patientName,
  } = props;

  const {
    submitPatientQuestionnaire,
    disableSubmit,
    questionnaire,
    error,
    isCreatingPatientQuestionnaire,
    isLoading,
  } = usePatientQuestionnaire({
    patientId,
    historyType: QuestionnaireType.Family,
  });

  if (isLoading) {
    return <Loading />;
  }

  if (!questionnaire || error) {
    return <FetchError />;
  }

  return (
    <FamilyQuestionnaireForm
      currentPage={currentPage}
      disableSubmit={disableSubmit || isCreatingPatientQuestionnaire}
      handleBack={handleBack}
      handlePageChange={handlePageChange}
      isCreatingPatientQuestionnaire={isCreatingPatientQuestionnaire}
      itemsPerPage={itemsPerPage}
      questionnaire={questionnaire}
      questionnaireType={QuestionnaireType.Family}
      submitPatientQuestionnaire={submitPatientQuestionnaire}
      patientName={patientName}
    />
  );
};

export default FamilyQuestionnaire;
